import React from 'react';
import { useHistory } from 'react-router-dom';
import { FiAlertOctagon } from 'react-icons/fi';

const SuspendedModal = ({ message, canManageBilling }) => {
  const history = useHistory();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white mx-4 p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
          <FiAlertOctagon className="h-8 w-8 text-red-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Account Suspended</h2>
        <p className="text-gray-600 mb-6">
          {message || 'Your account has been suspended due to payment being 30+ days overdue. Please complete your payment to restore access.'}
        </p>
        {canManageBilling ? (
          <button
            onClick={() => history.push('/billing')}
            className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold rounded-full px-6 py-3 transition-colors"
          >
            Go to Billing
          </button>
        ) : (
          <p className="text-sm text-gray-500">
            Please contact your school administrator to resolve this.
          </p>
        )}
      </div>
    </div>
  );
};

export default SuspendedModal;
